import { render, staticRenderFns } from "./BonusAlert.vue?vue&type=template&id=2a11fab8&scoped=true"
import script from "./BonusAlert.vue?vue&type=script&lang=js"
export * from "./BonusAlert.vue?vue&type=script&lang=js"
import style0 from "./BonusAlert.vue?vue&type=style&index=0&id=2a11fab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a11fab8",
  null
  
)

export default component.exports